export const formatValueOnSave = (value: number | string) => {
  let valueString = value.toString();

  valueString = valueString.replace(/\./g, '');
  valueString = valueString.replace(',', '.');

  return valueString;
};
